import { useCallback } from 'react';
import { awsAuthService } from '../utils/awsAuth';
import { useAWSAuth } from './useAWSAuth';

export interface UseAdminFunctionReturn {
  callFunction: (functionName: string, args?: any) => Promise<any>;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export const useAdminFunction = (): UseAdminFunctionReturn => {
  const { isAuthenticated, isLoading, error } = useAWSAuth();

  const callFunction = useCallback(async (functionName: string, args: any = {}): Promise<any> => {
    if (!isAuthenticated) {
      throw new Error('Not authenticated with AWS. Please log in again.');
    }

    try {
      return await awsAuthService.callFunction(functionName, args);
    } catch (error) {
      console.error('Admin function call failed:', error);
      throw error;
    }
  }, [isAuthenticated]);

  return {
    callFunction,
    isAuthenticated,
    isLoading,
    error
  };
};
